import { createApi } from '@reduxjs/toolkit/query/react'

import { apiPrivate } from '~/redux/utils/hom-api'

import { LastActivityCurriculum } from '../types/curriculum.types'

export const curriculumUserStatApi = createApi({
  reducerPath: 'curriculumUserStatApi',
  baseQuery: apiPrivate,
  tagTypes: ['CurriculumUserStats'],
  endpoints: (builder) => ({
    getCurriculumLastActivity: builder.query<LastActivityCurriculum, { eventName: string }>({
      query: (params) => ({
        url: '/v1/user-stats/curriculum/last-activity',
        method: 'GET',
        params,
      }),
      providesTags: ['CurriculumUserStats'],
    }),
  }),
})

export const { useGetCurriculumLastActivityQuery } = curriculumUserStatApi
